function setCookie (name, language) {
  window.document.cookie = name + '=' + language
}
export default setCookie



// WEBPACK FOOTER //
// ./src/utilits/index.js